export default __webpack_public_path__ + "static/media/RoomBuilderLogoGreen.619c486a.png";